// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from '../../../../node_module_clones/recompose';
import { includes } from 'lodash/fp';

// Utils
import liveCollaborationStoreConnect from '../store/liveCollaborationStoreConnect';
import { createShallowSelector } from '../../../utils/milanoteReselect/milanoteReselect';

// Selectors
import { getLiveCursorPositions } from './liveCursorSelector';
import getGridSize from '../../../utils/grid/gridSizeSelector';
import { getRemoteUserIdsAlreadyShowingActivity } from '../../remoteSelectedElementsSelector';
import { liveDrawingEditedElementIdsSelector } from '../../../element/drawing/store/liveDrawingSelector';

// Components
import LiveCursor from './LiveCursor';

// Styles
import './LiveCursorDisplay.scss';
import { debugToolProperty } from '../../../debug/store/debugToolSelector';
import { DEBUG_TOOLS } from '../../../debug/store/debugToolConstants';

const mapStateToProps = createStructuredSelector({
    gridSize: getGridSize,
    remoteUserIdsAlreadyShowingActivity: getRemoteUserIdsAlreadyShowingActivity,
    debugShowCursorState: debugToolProperty(DEBUG_TOOLS.LIVE_CURSOR, 'showCursorState'),
});

const getCursorIsSelecting = (userId, remoteUserActivity, liveDrawingEditedElementIds) => {
    const selectedButNotEditedActivity = remoteUserActivity
        .filter(([_, elementId]) => !includes(elementId, liveDrawingEditedElementIds))
        .map(([remoteUserId]) => remoteUserId);

    return includes(userId, selectedButNotEditedActivity);
};

const liveCursorSelector = createShallowSelector(
    getLiveCursorPositions,
    (_, { remoteUserIdsAlreadyShowingActivity }) => remoteUserIdsAlreadyShowingActivity,
    liveDrawingEditedElementIdsSelector,
    (allLiveCursors, remoteUserIdsAlreadyShowingActivity, liveEditedDrawingElementIds) =>
        allLiveCursors
            .map((entry, userId) => ({
                ...entry,
                userId,
                isSelecting: getCursorIsSelecting(
                    userId,
                    remoteUserIdsAlreadyShowingActivity,
                    liveEditedDrawingElementIds,
                ),
            }))
            .filter(({ x, y }) => !!x && !!y)
            .toArray(),
);

const mapLiveCollaborationStateToProps = createStructuredSelector({
    liveCursors: liveCursorSelector,
});

const LiveCursorDisplay = ({ liveCursors, gridSize, debugShowCursorState, translation, currentBoardId }) => (
    <div className="LiveCursorDisplay">
        {liveCursors.map((cursor) => (
            <LiveCursor
                key={cursor.userId}
                gridSize={gridSize}
                userId={cursor.userId}
                currentBoardId={currentBoardId}
                cursor={cursor}
                translation={translation}
                debugShowCursorState={debugShowCursorState}
            />
        ))}
    </div>
);

const enhancer = compose(connect(mapStateToProps), liveCollaborationStoreConnect(mapLiveCollaborationStateToProps));

LiveCursorDisplay.propTypes = {
    liveCursors: PropTypes.array,
    translation: PropTypes.object,
    gridSize: PropTypes.number,
    debugShowCursorState: PropTypes.bool,
    currentBoardId: PropTypes.string,
};

export default enhancer(LiveCursorDisplay);
